import React from "react"

export default function Footer() {
    return (
        <div id="footer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-4">
                        <div><a href="/"><img id="footlogo" src="../images/logo.png" /></a></div>
                        <div className="foottext">© 2015-2021 Все права защищены.</div>
                    </div>
                    <div className="col-sm-4 text-center">
                            <a href="#"><img src="../images/vk.png"/></a>&#32
                            <a href="#"><img src="../images/insta.png"/></a>&#32
                            <a href="#"><img src="../images/youtube.png"/></a>
                    </div>
                    <div className="col-sm-4">
                        <div className="foottext" align="right">Бесплатная консультация<br />Время работы — круглосуточно</div>
                        <div align="right"><img src="../images/phone.png"/> <a id="phone" href="tel:+79999999999">+7 999 999 99 99</a></div>
                    </div>
                </div>
            </div>
        </div>
    )
}